import { Theme } from './symbols';

export const icrisatTheme: Theme = {
    name: 'icrisat',
    properties: {
        // // Icrisat 
        // '--corecolour': '#262626',
        // '--corecolour1': '#262626',
        // '--corecolour-hover': '#1a1a1a',
        // '--secondarycolour': '#115519',
        // '--secondarycolour-hover': '#0d3f13',
        // '--secondarycolour-mild': '#aaeeb2',
        // '--tertiarycolour': '#28a745',
        // '--checkbox-indcolour': '#ff6600',
        // '--matformfield-colour': '#4d4d4d',
        // '--sidetoggle-gradient1': '#404040',
        // '--sidetoggle-gradient2': '#262626',
        // '--fab-gradient1': '#23a932',
        // '--fab-gradient2': '#115519',
        // //Action button 
        // '--actionbutton-gradient1': 'red',
        // '--actionbutton-gradient2': 'maroon',
        // //Divider Gradient 
        // '--divider-gradient1': 'rgb(27, 142, 241)',
        // '--divider-gradient2': 'rgb(27, 142, 241)',
        // //Admin Gradient gold
        // '--admin-gradient1': '#eed890',
        // '--admin-gradient2': '#deb221',
        '--alignment': 'rtl',
        '--text-align': 'right',
        '--padding': '0 0 0 8px',
        '--margin-right': '0%',
        '--right-radius': '0px',
        '--left-radius': '2px',
        '--border': '0px 0 0 1px solid rgba(0, 0, 0, 0.12)',
        '--border-right-width': '3px',
        '--border-left-width': '0px',
        '--arabic-direction': 'row-reverse',
        '--arabic-top-right-radius': '7px',
        '--arabic-bottom-right-radius': '7px',
        '--arabic-top-left-radius': '0px',
        '--arabic-bottom-left-radius': '0px',
        '--arabic-align-end': 'flex-end',
        '--arabic-left': '-1px',
        '--arabic-padding-right': '12px',
        '--float': 'left',
      




        // border-top-right-radius: 0px !important;
        // border-bottom-right-radius: 0px !important;
        // border-top-left-radius: 7px !important;
        // border-bottom-left-radius: 7px !important;

    }
};
